import { render } from "./Orthopaedics.vue?vue&type=template&id=dcd63594&scoped=true"
import script from "./Orthopaedics.vue?vue&type=script&lang=ts"
export * from "./Orthopaedics.vue?vue&type=script&lang=ts"

import "./Orthopaedics.vue?vue&type=style&index=0&id=dcd63594&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dcd63594"

export default script